// @flow

import _ from 'lodash';
import BookingConstants from '../constants/BookingConstants';

export default class BookingUtils {

  static getPeriodList(): Array<number> {
    const list = [];
    _.forIn(BookingConstants.Period, (value: number, key) => {
      list.push(value);
    });

    return list;
  }

  static generateSlotsForInterval(begin, end, interval) {
    const res = [];

    for (let i = begin; i <= end; i += interval) {
      res.push(i);
    }

    return res;
  }
}
